import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import Button from '../components/ui/Button'
import SEO from '../components/SEO'
import { MODULES } from '../utils/mockData'

const BREADCRUMB = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://myschoolportal.xyz' },
    { '@type': 'ListItem', position: 2, name: 'Features', item: 'https://myschoolportal.xyz/features' },
  ],
}

export default function Features() {
  return (
    <div className="pb-16">
      <SEO
        title="Eleven Modules, Every One Connected"
        description="Turn on what your school needs today. Every module shares the same records, the same permissions and the same reports."
        path="/features"
        schema={[BREADCRUMB]}
      />

      {/* Hero */}
      <section className="px-4 pt-16 pb-14 text-center bg-grid-pattern">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-display font-extrabold text-ink leading-[1.1] mb-5">
            Eleven modules.<br />Every one connected.
          </h1>
          <p className="text-lg text-[var(--ink-soft)] leading-relaxed">
            Turn on what your school needs today. Every module shares the same records, the same permissions and the same reports.
          </p>
        </div>
      </section>

      {/* Module deep-dives */}
      <section className="px-4 py-10 border-t border-theme">
        <div className="max-w-3xl mx-auto">
          {MODULES.map((mod, i) => (
            <div
              key={mod.id}
              id={mod.id}
              className={`grid md:grid-cols-[220px_1fr] gap-4 md:gap-8 py-8 scroll-mt-24 ${i > 0 ? 'border-t border-theme' : ''}`}
            >
              <div className="flex items-baseline gap-2.5">
                <span className="font-boxy text-xs font-bold text-accent">{String(i + 1).padStart(2, '0')}</span>
                <h2 className="text-xl font-display font-bold text-ink">{mod.name}</h2>
              </div>
              <div>
                <p className="text-sm text-[var(--ink-soft)] leading-relaxed mb-4 max-w-lg">{mod.desc}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
                  {mod.features.map((f) => (
                    <div key={f} className="flex items-baseline gap-2 text-sm text-ink">
                      <span className="w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0" style={{ background: 'var(--accent)', transform: 'translateY(-2px)' }} />
                      {f}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="rounded p-10 sm:p-14 flex flex-col sm:flex-row items-center justify-between gap-8" style={{ background: 'var(--panel-dark)' }}>
            <div>
              <h2 className="text-2xl sm:text-3xl font-display font-bold text-white mb-2">Ready to see it in action?</h2>
              <p style={{ color: 'var(--panel-dark-soft)' }}>Get in touch and we'll set up your school today.</p>
            </div>
            <div className="flex flex-wrap gap-3 flex-shrink-0">
              <Link to="/contact">
                <Button variant="primary" size="lg" className="!bg-[var(--accent-strong)] hover:!bg-[var(--accent)]">
                  Contact sales <ArrowRight size={16} />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
